import { Modal } from '@didi-pebble/pebble-design-react';
import { useEffect } from 'react';

const CommonModal = (props: any) => {
  const modalProps = {
    className: 'common-modal',
    wrapClassName: 'controlModal',
    title: props?.title,
    open: props?.visible,
    width: props?.width || 385,
    closable: props?.closable !== false, // 默认为true
    maskClosable: false,
    onCancel: props?.onCancel,
    cancelText: props?.cancelText,
    cancelButtonProps: props?.cancelButtonProps || {},
    onOk: props?.onOk,
    okText: props?.okText,
    okButtonProps: props?.okButtonProps || {},
    footer: props?.footer || undefined,
    zIndex: 3000,
    centered: true
  };

  useEffect(() => {
    if (props.visible) {
      props?.initFunc?.();
    }
  }, [props.visible]);

  return (
    <Modal {...modalProps}>
      <p>{props?.text}</p>
    </Modal>
  );
};

export default CommonModal;
